function synchronisationController($translate, $state, $scope, WS, $window) {
    'ngInject';
    const vm = this;
    vm.synchronisation = [];
    vm.new_synchronisation = {};
    vm.details = {};
    vm.filters = {
        user_code: [],
        categorie_code: [],
        activite_code: [],
        zone_code: [],
        region_code: [],
        secteur_code: [],
        gouvernorat_code: [],
        delegation_code: [],
        localite_code: [],
        routing_code: []
    };

    vm.filterActivitesByCategories = function (activite) {
        return !vm.filters.categorie_code.length || vm.filters.categorie_code.indexOf(activite.categorie_code) !== -1;
    };

    vm.getSynchronisation = function () {

      const data = {
                user_code: vm.filters.user_code,
                categories: vm.res_tabs_cats,
                zones : vm.filters.zone_code,
                region_code : vm.filters.region_code,
                secteur_code : vm.filters.secteur_code,
                gouvernorat_code : vm.filters.gouvernorat_code,
                delegation_code : vm.filters.delegation_code,
                localites : vm.filters.localite_code,
                routing_code : vm.filters.routing_code,
                categorie_code: vm.filters.categorie_code,
                activite_code: vm.filters.activite_code
            };

        WS.post('synchronisation', data)
            .then(function (response) {
                vm.synchronisation = response.data;
                vm.synchronisation_filters = response.data;
                vm.selected = {};
                vm.selectedIds = [];
                vm.selectAllChecked = false;
                $scope.$apply();
            })
            .then(null, function (error) {
                console.log(error);
            });
    };

    vm.selected = {};
    vm.selectedIds = [];
    vm.selectAllChecked = false;

    vm.toggleSelect = function () {
        vm.selectedIds = Object.keys(vm.selected).filter(key => vm.selected[key] === true).map(key => Number(key));
        vm.selectAllChecked = _.size(vm.synchronisation) > 0 && vm.selectedIds.length === _.size(vm.synchronisation);
    };

    vm.toggleSelectAll = function () {
        vm.selected = {};
        _.each(vm.synchronisation, function (value) {
            vm.selected[value.id] = vm.selectAllChecked;
        });
        vm.selectedIds = vm.selectAllChecked ? _.pluck(vm.synchronisation, 'id') : [];
    };

    vm.deleteMultiple = function () {

        swal({
            title: $translate.instant('synchronisation'),
            text: $translate.instant('voulez vous vraiment supprimer les synchronisations sélectionnées!'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: $translate.instant('Oui'),
            cancelButtonText: $translate.instant('Non'),
            confirmButtonClass: 'btn btn-success',
            cancelButtonClass: 'btn btn-danger',
            buttonsStyling: false
        }).then(function () {
            WS.post('synchronisation/deleteMultiple', { ids: vm.selectedIds }).then(
                function () {
                    swal(
                        $translate.instant('Succès'),
                        $translate.instant('synchronisations supprimées avec Succès.'),
                        'success'
                    ).then(function () {
                        $window.location.reload();
                    });
                },
                function () {
                    swal(
                        $translate.instant('Attention!'),
                        $translate.instant('vous ne pouvez pas supprimer ces synchronisations!!'),
                        'warning'
                    );
                }
            );
        });
    };

    vm.selectSecteurs = () => {
        WS.get('secteurs')
            .then(function (response) {
                vm.secteurs = response.data;
                $scope.$apply();
            })
            .then(null, function (error) {
                console.log(error);
            });
    };

    vm.selectRegions = () => {
        WS.get('regions/selectRegions')
            .then(function (response) {
                vm.regions = response.data;
                $scope.$apply();
            })
            .then(null, function (error) {
                console.log(error);
            });
    };

    vm.selectRoutings = () => {
        WS.get('routing/selectRoutes')
            .then(function (response) {
                vm.routings = response.data;
                $scope.$apply();
            })
            .then(null, function (error) {
                console.log(error);
            });
    };

    vm.selectFilterDelegations = () => {
        WS.post('delegations/selectDelegations', { gouvernorat_code: vm.filters.gouvernorat_code })
            .then(function (response) {
                if (response.status == 200) {
                    vm.filterDelegations = response.data;
                    $scope.$apply();
                }
            })
            .then(null, function (error) {
                console.log(error);
            });
    };

    vm.selectFilterLocalites = () => {
        WS.post('localites/selectLocalitesBySearch', {
            gouvernorat_code: vm.filters.gouvernorat_code,
            delegation_code: vm.filters.delegation_code
        })
            .then(function (response) {
                if (response.status == 200) {
                    vm.filterLocalites = response.data;
                    $scope.$apply();
                }
            })
            .then(null, function (error) {
                console.log(error);
            });
    };

    vm.selectCategories = () => {
        WS.get('categoriescommerciale')
            .then(function (response) {
                if (response.status == 200) {
                    vm.categories = response.data;
                    $scope.$apply();
                }
            })
            .then(null, function (error) {
                console.log(error);
            });
    };

    vm.selectActivites = () => {
        WS.get('activites')
            .then(function (response) {
                if (response.status == 200) {
                    vm.activites = response.data;
                    $scope.$apply();
                }
            })
            .then(null, function (error) {
                console.log(error);
            });
    };

    vm.selectAddDelegations = () => {
        WS.post('delegations/selectDelegations', { gouvernorat_code: vm.new_synchronisation.gouvernorat_code })
            .then(function (response) {
                if (response.status == 200) {
                    vm.addDelegations = response.data;
                    $scope.$apply();
                }
            })
            .then(null, function (error) {
                console.log(error);
            });
    };

    vm.selectAddLocalites = () => {
        WS.post('localites/selectLocalitesBySearch', {
            gouvernorat_code: vm.new_synchronisation.gouvernorat_code,
            delegation_code: vm.new_synchronisation.delegation_code
        })
            .then(function (response) {
                if (response.status == 200) {
                    vm.addLocalites = response.data;
                    $scope.$apply();
                }
            })
            .then(null, function (error) {
                console.log(error);
            });
    };


    vm.selectUsers = () => {
        WS.get('users/selectUsers')
            .then(function (response) {
                vm.selectusers = response.data;
                $scope.$apply();
            })
            .then(null, function (error) {
                console.log(error);
            });
    };

    vm.getcategories = function () {
        WS.get('categoriescommerciale')
            .then(function (response) {
                if (response.status == 200) {
                    vm.categories = response.data;
                    $scope.$apply();
                } else { }
            })
            .then(null, function (error) {
                console.log(error);
            });
    }


    vm.getActivites = function () {
        WS.get('activites')
            .then(function (response) {
                if (response.status == 200) {
                    vm.activites = response.data;

                    $scope.$apply();
                }
            })
            .then(null, function (error) {
                console.log(error);
            });
    }

    vm.selectZones = () => {
        WS.get('zones/selectZones')
            .then(function (response) {
                vm.zones = response.data;
                $scope.$apply();
            })
            .then(null, function (error) {
                console.log(error);
            });
    };


    vm.update = function() {

         WS.post('synchronisation/update' , vm.details)
             .then(function(response) {
                 if (response.status == 200) {
                     swal(
                         'Succès',
                         'synchronisation modifiée avec Succès',
                         'success'
                     ).then(function() {
                         $window.location.reload();
                     });
                 } else {}
             })
             .then(null, function(error) {
                 console.log(error);
             });
     }

     vm.delete = function(id) {

         swal({
             title: $translate.instant('synchronisation'),
             text: $translate.instant("voulez vous vraiment supprimer cette synchronisation!"),
             type: 'warning',
             showCancelButton: true,
             confirmButtonColor: '#3085d6',
             cancelButtonColor: '#d33',
             confirmButtonText: $translate.instant('Oui'),
             cancelButtonText: $translate.instant('Non'),
             confirmButtonClass: 'btn btn-success',
             cancelButtonClass: 'btn btn-danger',
             buttonsStyling: false
         }).then(function() {
             WS.post('synchronisation/delete' , {id}).then(
                 function() {
                     swal(
                        $translate.instant('Succès'),
                        $translate.instant('synchronisation supprimée avec Succès.'),
                         'success'
                     ).then(function() {
                         $window.location.reload();
                     });
                 },
                 function() {
                     swal(
                        $translate.instant('Attention!'),
                        $translate.instant('vous ne pouvez pas supprimer cette synchronisation!!'),
                         'warning'
                     );
                 }
             );
         });
     }

     vm.ajouter = function() {

        WS.post('synchronisation/store', vm.new_synchronisation)
        .then(function (response) {
            if (response.data.success == true) {

                swal(
                    $translate.instant('Succès'),
                    $translate.instant('synchronisation ajoutée avec Succès'),
                     'success'
                 ).then(function() {
                     $window.location.reload();
                 });
            } else {
                swal(
                    $translate.instant('Error'),
                    $translate.instant(response.data.message),
                    'error'
                 );
            }
        }, function (error) {
            console.log(error);
        });
     }




     vm.tabs_cats = [];
    vm.res_tabs_cats = [];

    vm.selectCategoriesWithActivites = () => {

        WS.get('plandecharges/selectCategoriesWithActivites')
            .then(function (response) {
                if (response.status == 200) {
                    vm.categories = response.data;
                    vm.max_activites = 0;
                    _.each(vm.categories, element => {
                        var nbr_act = element.activites.length;
                        if (nbr_act > vm.max_activites) {
                            vm.max_activites = nbr_act;
                        }

                        vm.tabs_cats[element.code] = false;
                        _.each(element.activites, activite => {
                            vm.tabs_cats[element.code + '_' + activite.code] = false;
                        })
                    })
                    $scope.$apply();
                }
            })
            .then(null, function (error) {
                console.log(error);
            });
    }

    vm.manage = (categorie_code, activite_code = null, type, activites) => {
        //console.log(categorie_code, activite_code);
        if (type == 'categorie') {
            vm.tabs_cats[categorie_code] = !vm.tabs_cats[categorie_code];
            if (vm.tabs_cats[categorie_code]) {
                if (activites.length > 0) {
                    _.each(activites, element => {
                        var index = vm.res_tabs_cats.findIndex(x => x.categorie_code == categorie_code && x.activite_code == element.code);
                        if (index == -1) {
                            vm.res_tabs_cats.push({
                                categorie_code: categorie_code,
                                activite_code: element.code
                            })
                            vm.tabs_cats[categorie_code + '_' + element.code] = true;
                            $(`#${categorie_code}_${element.code}>i`).removeClass('glyphicon-unchecked').addClass('glyphicon-check')

                        }
                    })
                    $(`#${categorie_code}>i`).addClass('glyphicon-check').removeClass('glyphicon-unchecked');
                } else {
                    var index = vm.res_tabs_cats.findIndex(x => x.categorie_code == categorie_code && x.activite_code == null);
                    if (index == -1) {
                        vm.res_tabs_cats.push({
                            categorie_code: categorie_code,
                            activite_code: null
                        })
                        vm.tabs_cats[categorie_code] = true;
                        $(`#${categorie_code}>i`).addClass('glyphicon-check').removeClass('glyphicon-unchecked')
                    }
                }
            } else {
                if (activites.length > 0) {
                    _.each(activites, element => {
                        var index = vm.res_tabs_cats.findIndex(x => x.categorie_code == categorie_code && x.activite_code == element.code);
                        if (index > -1) {
                            vm.res_tabs_cats.splice(index, 1);
                            vm.tabs_cats[categorie_code + '_' + element.code] = false;
                            $(`#${categorie_code}_${element.code}>i`).removeClass('glyphicon-check').addClass('glyphicon-unchecked')
                        }
                    })
                    $(`#${categorie_code}>i`).removeClass('glyphicon-check').addClass('glyphicon-unchecked');

                } else {
                    var index = vm.res_tabs_cats.findIndex(x => x.categorie_code == categorie_code && x.activite_code == null);
                    if (index > -1) {
                        vm.res_tabs_cats.splice(index, 1);
                        vm.tabs_cats[categorie_code] = false;
                        $(`#${categorie_code}>i`).removeClass('glyphicon-check').addClass('glyphicon-unchecked')
                    }
                }
            }



        } else if (type == 'activite') {
            vm.tabs_cats[categorie_code + '_' + activite_code] = !vm.tabs_cats[categorie_code + '_' + activite_code];

            if (vm.tabs_cats[categorie_code + '_' + activite_code]) {
                var index = vm.res_tabs_cats.findIndex(x => x.categorie_code == categorie_code && x.activite_code == activite_code);
                //console.log(index)
                if (index == -1) {
                    vm.res_tabs_cats.push({
                        categorie_code: categorie_code,
                        activite_code: activite_code
                    })
                    vm.tabs_cats[categorie_code] = true;
                    $(`#${categorie_code}>i`).addClass('glyphicon-check').removeClass('glyphicon-unchecked')
                    $(`#${categorie_code}_${activite_code}>i`).addClass('glyphicon-check').removeClass('glyphicon-unchecked')
                }
            } else {
                var index = vm.res_tabs_cats.findIndex(x => x.categorie_code == categorie_code && x.activite_code == activite_code);
                //console.log(index)
                if (index > -1) {
                    vm.res_tabs_cats.splice(index, 1);
                    //vm.tabs_cats[categorie_code] =false;
                    //$(`#${categorie_code}>i`).removeClass('glyphicon-check').addClass('glyphicon-unchecked')
                    $(`#${categorie_code}_${activite_code}>i`).removeClass('glyphicon-check').addClass('glyphicon-unchecked')
                }
            }

        }
        //console.log('clicked_cats', vm.res_tabs_cats)

    }

    vm.changeUser = ()=> {
        var resultat = vm.synchronisation_filters.filter(sync => sync.user_code == vm.new_synchronisation.user_code);
        var zones = _.pluck(resultat, 'zone_code');
        vm.new_synchronisation.zone_code  = _.uniq(zones);
        //console.log(zones, vm.new_synchronisation.zone_code);
        vm.res_tabs_cats = [];


        _.each(vm.categories, element => {
            var nbr_act = element.activites.length;
            if (nbr_act > vm.max_activites) {
                vm.max_activites = nbr_act;
            }
            vm.tabs_cats[element.code] = false;
            $(`#${element.code}>i`).removeClass('glyphicon-check').addClass('glyphicon-unchecked')

            _.each(element.activites, activite => {
                vm.tabs_cats[element.code + '_' + activite.code] = false;
                $(`#${element.code}_${activite.code}>i`).removeClass('glyphicon-check').addClass('glyphicon-unchecked')

            })
        })



        _.each(resultat, (element, index) => {
            vm.tabs_cats[element.categorie_code] = true;
            vm.tabs_cats[element.categorie_code + '_' + element.activite_code] = true;

            vm.res_tabs_cats.push({
                categorie_code: element.categorie_code,
                activite_code: element.activite_code
            })
            $(`#${element.categorie_code}_${element.activite_code}>i`).addClass('glyphicon-check').removeClass('glyphicon-unchecked')
            $(`#${element.categorie_code}>i`).addClass('glyphicon-check').removeClass('glyphicon-unchecked')

        })
    }

    vm.selectGouvernorats = () => {
        WS.get('gouvernorats/selectGouvernorats')
            .then(function (response) {
                vm.gouvernorats = response.data;
                $scope.$apply();
            })
            .then(null, function (error) {
                console.log(error);
            });
    };

    vm.selectDelegations = function () {
        WS.getData('delegations/selectDelegations', { gouvernorat_code: vm.new_synchronisation.gouvernorat_code })
            .then(function (response) {
                if (response.status == 200) {
                    vm.delegations = response.data;
                    $scope.$apply();
                } else { }
            })
            .then(null, function (error) {
                console.log(error);
            });
    };

    vm.selectLocalites = function ( ) {
        WS.getData('localites/selectLocalites', { delegation_code : vm.new_synchronisation.delegation_code })
            .then(function (response) {
                if (response.status == 200) {

                    vm.localites = response.data;

                    $scope.$apply();
                } else { }
            })
            .then(null, function (error) {
                console.log(error);
            });
    }

    vm.addSynchronisation = () => {
        //console.log(vm.listProds);

        if (vm.user_code == '') {
            swal('Oups!', 'Veuillez bien remplir le champ libelle', 'warning');
        }
        // else if (vm.res_tabs_cats.length == 0) {
        //     swal('Oups!', 'Veuillez bien selectionner au moins une catégorie', 'warning');
        // }
         else {
            const data = {
                user_code: vm.new_synchronisation.user_code,
                categories: vm.res_tabs_cats,
                zones : vm.new_synchronisation.zone_code,
                gouvernorat_code : vm.new_synchronisation.gouvernorat_code,
                delegation_code : vm.new_synchronisation.delegation_code,
                localites : vm.new_synchronisation.localite_code
            };

            console.log(data);


            WS.post('synchronisation/store', data)
                .then(function (response) {
                    if (response.status == 200) {
                        swal(
                            $translate.instant('Succé'),
                            $translate.instant('Plan de charge ajoutée avec succées'),
                            'success'
                        ).then(function () {
                            $window.location.reload();
                        })
                    }
                })
                .then(null, function (error) {
                    console.log(error);
                });

        }

    }

    vm.selectSynchronisationByUser = () => {

        if (!vm.new_synchronisation.user_code) {
            return;
        }

        vm.loadingSelectSynchronisationByUser = true;

        WS.post('synchronisation', { user_code: [vm.new_synchronisation.user_code] })
            .then(function (response) {
                var lignes = response.data;

                vm.new_synchronisation.gouvernorat_code = _.uniq(_.compact(_.pluck(lignes, 'gouvernorat_code')));
                vm.new_synchronisation.delegation_code = _.uniq(_.compact(_.pluck(lignes, 'delegation_code')));
                vm.new_synchronisation.localite_code = _.uniq(_.compact(_.pluck(lignes, 'localite_code')));
                vm.new_synchronisation.zone_code = _.uniq(_.compact(_.pluck(lignes, 'zone_code')));
                vm.new_synchronisation.secteur_code = _.uniq(_.compact(_.pluck(lignes, 'secteur_code')));
                vm.new_synchronisation.region_code = _.uniq(_.compact(_.pluck(lignes, 'region_code')));
                vm.new_synchronisation.routing_code = _.uniq(_.compact(_.pluck(lignes, 'routing_code')));
                vm.new_synchronisation.categorie_code = _.uniq(_.compact(_.pluck(lignes, 'categorie_code')));
                vm.new_synchronisation.activite_code = _.uniq(_.compact(_.pluck(lignes, 'activite_code')));

                vm.selectAddDelegations();
                vm.selectAddLocalites();

                vm.loadingSelectSynchronisationByUser = false;
                $scope.$apply();
            })
            .then(null, function (error) {
                vm.loadingSelectSynchronisationByUser = false;
                $scope.$apply();
                console.log(error);
            });
    };

    vm.addSynchronisationMultiple = () => {

        if (!vm.new_synchronisation.user_code) {
            swal('Oups!', 'Veuillez bien choisir un commercial', 'warning');
        } else {
            const data = {
                user_code: vm.new_synchronisation.user_code,
                gouvernorat_code: vm.new_synchronisation.gouvernorat_code,
                delegation_code: vm.new_synchronisation.delegation_code,
                localite_code: vm.new_synchronisation.localite_code,
                zone_code: vm.new_synchronisation.zone_code,
                secteur_code: vm.new_synchronisation.secteur_code,
                region_code: vm.new_synchronisation.region_code,
                routing_code: vm.new_synchronisation.routing_code,
                categorie_code: vm.new_synchronisation.categorie_code,
                activite_code: vm.new_synchronisation.activite_code
            };

            vm.loadingAddSynchronisation = true;

            WS.post('synchronisation/storeMultiple', data)
                .then(function (response) {
                    vm.loadingAddSynchronisation = false;
                    $scope.$apply();
                    if (response.data.success == true) {
                        swal(
                            $translate.instant('Succé'),
                            $translate.instant('Synchronisation ajoutée avec succées'),
                            'success'
                        ).then(function () {
                            $window.location.reload();
                        })
                    } else {
                        swal(
                            $translate.instant('Error'),
                            $translate.instant(response.data.message),
                            'error'
                        );
                    }
                })
                .then(null, function (error) {
                    vm.loadingAddSynchronisation = false;
                    $scope.$apply();
                    console.log(error);
                });
        }

    }

}
export default {
    name: 'synchronisationController',
    fn: synchronisationController
};
